export const Jobs =  [
    "Administrador",
    "Advogado",
    "Biomédico",
    "Comerciário",
    "Contabilista",
    "Corretor de Imóveis",
    "Corretor de Seguros",
    "Dentista",
    "Despachante Aduaneiro",
    "Empreiteiro",
    "Empresário",
    "Engenheiro/Arquiteto/Agrônomo",
    "Economista",
    "Enfermeiro",
    "Estudante",
    "Farmacêutico",
    "Fisioterapeuta",
    "Funcionário Público",
    "Jornalista",
    "Médico",
    "Médico Veterinário",
    "Mestre de Obra",
    "Nutricionista",
    "Orientador Educacional",
    "Professor",
    "Profissional Liberal",
    "Publicitário/Agenciador de Propaganda",
    "Representante Comercial",
    "Outros"
];


// WEBPACK FOOTER //
// ./src/utils/modals/jobs.js